import { commandComponents } from './utils/appCommandComponents';
import { useCommandKeybindings } from './utils/useCommandKeybindings';

/** Represents a hook that sets up command keybindings and their handlers. */
export function useRegisterCommandHandlers(): typeof commandComponents | null {
  useCommandKeybindings();

  return commandComponents;
}
